import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import type { DrillPageGlyphPromptGate } from "#use-drill-page-glyph-prompt-gate";

export type DrillPageGlyphPromptVariant = "portrait" | "landscape";

/** The in-card answer prompt. Only `useDrillPageGlyphPromptGate` decides whether it shows. */
export function DrillPageGlyphPrompt({
  gate,
  variant,
}: {
  gate: DrillPageGlyphPromptGate;
  variant: DrillPageGlyphPromptVariant;
}) {
  const className =
    variant === "portrait"
      ? "mt-6 text-center text-base text-muted-foreground"
      : "pb-2 text-center text-base text-muted-foreground";

  return <Text className={className}>{gate.text}</Text>;
}
